import React from 'react';
import { Alert, Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import useStyles from './styles';
// eslint-disable-next-line import/no-extraneous-dependencies
import DOMPurify from 'dompurify';

/**
 * A page banner: the two-factor reminder and the banners admins publish (LB-5968). A strip, not a card -- the
 * severity icon, the title over its text, the action beside them and the close -- because several of these can
 * stack above every page, and as cards they pushed the page itself below the first screen.
 */
export default function InformationBanner(_ref) {
  let type = _ref.type,
    text = _ref.text,
    title = _ref.title,
    btnLink = _ref.btnLink,
    btnTitle = _ref.btnTitle,
    _ref$btnTarget = _ref.btnTarget,
    btnTarget = _ref$btnTarget === void 0 ? '_blank' : _ref$btnTarget,
    handleCross = _ref.handleCross;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.alertWrapper
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: type,
    size: "small",
    onClose: handleCross ? () => handleCross() : undefined
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.copy
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    className: classes.title
  }, title || 'Notification title'), text && text.length && /*#__PURE__*/React.createElement("div", {
    className: classes.bannerContent,
    dangerouslySetInnerHTML: {
      __html: DOMPurify.sanitize(text)
    }
  })), btnLink && btnTitle && /*#__PURE__*/React.createElement(Button, {
    className: classes.action,
    component: RouterLink,
    to: btnLink,
    target: btnTarget,
    variant: "text",
    size: "small",
    'custom-attribute': '336-InformationBanner'
  }, btnTitle))));
}